// extracted by mini-css-extract-plugin
export default {"p_content":"bc54bbbbc2"};